// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hulK5","type":"styles_type__vOPJo","choices":"styles_choices__1hGS8"};